/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    studentdetails: ''
  },
  mutations: {
    setStudentData (state, studentdetails) {
      state.studentdetails = studentdetails
    },
    reset(state){
      state.studentdetails=''
    }
},
actions: {
    getStudentById ({commit}, id) {
        if (id) {
          api.getData('admin/student/' + id).then(
          res => {

            var students = res.data
            commit('setStudentData', students)
          })
        }
      },
      getStudentTeacherById ({commit}, id) {
        if (id) {
          api.getData('admin/view_teacher_for_student/',id).then(
          res => {

            var students = res.data
            commit('setStudentData', students)
          })
        }
      },
}
}



// WEBPACK FOOTER //
// ./src/store/modules/Students.js